import {
  ADDPRODUCT,
  ADDTOCART,
  DECREMENT,
  INCREMENT,
  REMOVE,
} from "./actionTypes";

const initialState = {
  products: [],
  cartProducts: [],
};

const productId = (products) => {
  const maxId = products.reduce(
    (maxId, product) => Math.max(product.id, maxId),
    -1
  );
  return maxId + 1;
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    //Add Product
    case ADDPRODUCT:
      return {
        ...state,
        products: [
          ...state.products,
          { ...action.payload, id: productId(state.products) },
        ],
      };
    //Add to Cart
    case ADDTOCART:
      const cartProductIndex = state?.cartProducts?.findIndex(
        (item) => item.id === action.payload.id
      );
      const productIndex = state.products?.findIndex(
        (item) => item.id === action.payload.id
      );
      state.products[productIndex].quantity -= 1;
      if (cartProductIndex >= 0) {
        state.cartProducts[cartProductIndex].cartQuantity += 1;
        return {
          ...state,
          cartProducts: [...state.cartProducts],
        };
      } else {
        return {
          ...state,
          cartProducts: [
            ...state.cartProducts,
            {
              ...action.payload,
              cartQuantity: 1,
            },
          ],
        };
      }
    case INCREMENT:
      const cartIndex = state?.cartProducts?.findIndex(
        (item) => item.id === action.payload.id
      );
      const index = state.products?.findIndex(
        (item) => item.id === action.payload.id
      );
      state.products[index].quantity -= 1;
      state.cartProducts[cartIndex].cartQuantity += 1;
      state.cartProducts[cartIndex].quantity -= 1;
      return {
        ...state,
        cartProducts: [...state.cartProducts],
      };
    case DECREMENT:
      const indexCart = state?.cartProducts?.findIndex(
        (item) => item.id === action.payload.id
      );
      const indexProduct = state.products?.findIndex(
        (item) => item.id === action.payload.id
      );
      state.cartProducts[indexCart].cartQuantity -= 1;
      state.products[indexProduct].quantity += 1;
      state.cartProducts[indexCart].quantity += 1;
      return {
        ...state,
        cartProducts: [...state.cartProducts],
      };
    case REMOVE:
      const indexedProduct = state.products?.findIndex(
        (item) => item.id === action.payload.id
      );
      const filteredProducts = state.cartProducts.filter(
        (item) => item.id !== action.payload.id
      );
      state.products[indexedProduct].quantity += action.payload?.cartQuantity;

      return {
        ...state,
        cartProducts: filteredProducts,
      };

    default:
      return state;
  }
};

export default reducer;
